// Client groups (step 8 part 3): client_groups + client_group_members. Reports take a group in the Clients pick and
// resolve it to its clients at run time, so a saved report keeps the GROUP and a client added later is in the next run.
// → { ok: true, data: [{ id, name, active, sort, clientIds: [...] }] } or { ok: false, error }
import { supabase } from '../supabase';

export async function loadClientGroups() {
  const { data, error } = await supabase.from('client_groups').select('id, name, active, sort, client_group_members(client_id)');
  if (error) return { ok: false, error: `Client groups could not be loaded: ${error.message}` };
  return {
    ok: true,
    data: (data || []).map((g) => ({ id: g.id, name: g.name, active: g.active, sort: g.sort, clientIds: (g.client_group_members || []).map((m) => m.client_id) }))
      .sort((a, b) => (a.sort - b.sort) || a.name.localeCompare(b.name)),
  };
}

// The clients a pick stands for: the clients picked one by one, plus every member of each picked group (once each).
export function resolveClientIds(clientIds, groupIds, groups) {
  const out = [...(clientIds || [])];
  (groupIds || []).forEach((gid) => (groups.find((g) => g.id === gid)?.clientIds || []).forEach((id) => { if (!out.includes(id)) out.push(id); }));
  return out;
}
